// Widget dropdown générique (menu "Répondre au courriel", "Fonction", "Thème", etc.) -- purement
// DOM, aucune dépendance sur l'état applicatif.
export interface DropdownHandle {
  getValue: () => string;
  setValue: (value: string) => void;
}

export function createDropdown(containerId: string, onChange?: (value: string) => void): DropdownHandle {
  const dropdownElement = document.getElementById(containerId);
  const triggerElement = dropdownElement.querySelector<HTMLElement>(".dropdown-trigger");
  const labelElement = dropdownElement.querySelector<HTMLElement>(".dropdown-trigger-label");
  const listElement = dropdownElement.querySelector<HTMLUListElement>(".dropdown-list");
  const itemElements = Array.from(listElement.querySelectorAll<HTMLLIElement>(".dropdown-item"));

  function setOpen(open: boolean): void {
    dropdownElement.classList.toggle("is-open", open);
    listElement.classList.toggle("is-hidden", !open);
    triggerElement.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function setValue(value: string): void {
    const matchedItem = itemElements.find((itemElement) => itemElement.getAttribute("data-value") === value);
    if (!matchedItem) {
      return;
    }
    labelElement.textContent = matchedItem.textContent;
    itemElements.forEach((itemElement) => {
      const isSelected = itemElement === matchedItem;
      itemElement.classList.toggle("is-selected", isSelected);
      itemElement.setAttribute("aria-selected", isSelected ? "true" : "false");
    });
  }

  function getValue(): string {
    return itemElements.find((itemElement) => itemElement.classList.contains("is-selected"))?.getAttribute("data-value") || "";
  }

  triggerElement.onclick = () => setOpen(listElement.classList.contains("is-hidden"));
  triggerElement.onkeydown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setOpen(listElement.classList.contains("is-hidden"));
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  };

  itemElements.forEach((itemElement) => {
    itemElement.onclick = () => {
      const value = itemElement.getAttribute("data-value");
      setValue(value);
      setOpen(false);
      triggerElement.focus();
      onChange?.(value);
    };
  });

  document.addEventListener("click", (event) => {
    if (event.target instanceof Node && !dropdownElement.contains(event.target)) {
      setOpen(false);
    }
  });

  return { getValue, setValue };
}
